<template>
    <div class="home" >
        <x-header v-if="isEdit=='2'" back>{{currGroupName?'['+currGroupName+']下的实验':''+'我的实验'}}</x-header>
        <x-header v-else>我的实验</x-header>
        <x-content v-if="loading" style="height:100%;" :contentStyle="{alignItems:'center',justifyContent:'center',height:'100%'}">
            <bounce-loading></bounce-loading>
        </x-content>
        <x-content v-else  :contentStyle="{display:'block',width:'calc(100% - 32px)',padding:'16px'}">
            <div class="search_warp">
                <el-row class="list-control_warp">
                    <el-col  style="display: flex; justify-content: space-between" :span="24">
                        <div   style="display:flex;width:38%">
                            <div style="width:45%">
<!--                              <el-select placeholder=""  v-model="searchType"   style="width:10%;">-->
<!--                                <el-option-->
<!--                                    v-for="item in searchOption"-->
<!--                                    :key="item.value"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value">-->
<!--                                </el-option>-->
<!--                              </el-select>-->
                                <el-input alwaysShowClear clearable v-model="searchText" @keydown.enter.native="search" placeholder="输入实验名称">
                                    <template slot="suffix">
                                        <i @click="search" style="cursor: pointer;" class="el-input__icon base-icon-search"></i>
                                    </template>
                                </el-input>
                            </div>
                            <div class="sort_set" style="display: block;margin-left: 15px;">
                                <el-select placeholder=""  v-model="sort" @change="listExperiment"  style="width:35%;margin-left: 15px;">
                                    <el-option
                                        v-for="item in sortOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <span style="cursor: pointer;" @click="changeSortType" v-html="sortTypeHtml"></span>
                            </div>
                        </div>
                        &nbsp;
                        <div>
                          <template v-if="experimentParentList.length>0">
                            <el-button type="success" size="small" v-if="isOpenAll" @click="ToExpandAll" icon="el-icon-arrow-right"> 一键展开</el-button>
                            <el-button type="success" plain size="small" v-if="!isOpenAll"  @click="ToClose" icon="el-icon-arrow-down"> 一键折叠</el-button>
                           </template>
                           <template v-if="groupData.archivingStatus!=1">
                            <el-button type="primary" size="small" plain @click="exportExcel"><i class="iconfont">&#xe601;</i> Excel</el-button>
                            <el-button type="primary" size="small"  plain @click="exportWordOrPdf('word')"><i class="iconfont">&#xe7ba;</i> Word</el-button>
                            <el-button type="primary" size="small"  plain @click="exportWordOrPdf('pdf')"><i class="iconfont">&#xe7b8;</i> Pdf</el-button>
                           </template>
                            <el-button type="primary" size="small" plain icon="el-icon-document-copy" @click="copyExperiment"> 复制</el-button>
                            <template v-if="groupData.archivingStatus!=1">
                            <el-button type="primary" size="small" plain icon="el-icon-share" @click="setShare"> 分享</el-button>
                            <el-button v-if="groupId" style="" size="small" type="primary" @click="openDialog" icon="base-icon-plus">
                                <span> 新建本项目实验</span>
                            </el-button>
                            <el-button v-else style="" size="small" type="primary" @click="openDialog" icon="base-icon-plus">
                                <span> 新建实验</span>
                            </el-button>
                            </template>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <x-card>
              <el-table
                  :data="experimentParentList"
                  stripe
                  empty-text="暂无实验"
                  @selection-change="handleSelectionChange1"
                  ref="experimentParentListTable"
                  style="width: 100%">
                <el-table-column
                    type="expand"
                    width="55">
                  <template slot-scope="scope0">
<!--                    @selection-change="$event => handleSelectionChange($event,scope0)"-->
                  <el-table
                      :data="scope0.row.experimentList"
                      :row-class-name="tableRowClassName"
                      ref="experiemnt"
                      empty-text="暂无子实验"
                      :show-header="false"
                      style="width: 100%;">
                    <el-table-column
                        width="55">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        type="selection"-->
<!--                        width="55">-->
<!--                    </el-table-column>-->
                    <el-table-column width="55" label="">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isSelect" :label="scope.row"  @change="(val) => handleSelect(val, scope.row)"><br></el-checkbox>
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="experiment_id"
                        label="实验编号">
                      <template slot-scope="scope">
                        <el-tooltip content="查看实验详情" placement="bottom">
                          <el-link style='color:#409EFF'  @click="$router.push('/manager/experiment/detail/'+scope.row._source.uuid+'/'+isEdit)" :underline="false">{{scope.row._source.experiment_id}}</el-link>
                        </el-tooltip>
                        <template v-if="scope.row._source.txid">
                          <el-tooltip content="查看存证证书" placement="top">
                            <span @click="loadCertificate(scope.row._source.txid)" class="loadCertificate">
                              <svg t="1712046094491" style="vertical-align: middle;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25529" width="22" height="22"><path d="M0 0m195.047619 0l633.904762 0q195.047619 0 195.047619 195.047619l0 633.904762q0 195.047619-195.047619 195.047619l-633.904762 0q-195.047619 0-195.047619-195.047619l0-633.904762q0-195.047619 195.047619-195.047619Z" fill="#007AFF" p-id="25530"></path><path d="M219.233524 288.621714v245.662476c0 161.962667 132.510476 295.521524 294.473143 294.473143 160.694857-1.048381 290.669714-131.584 290.669714-292.571428V288.621714a45.056 45.056 0 0 0-45.007238-45.007238H264.240762a45.056 45.056 0 0 0-45.007238 45.007238z" fill="#FFFFFF" p-id="25531"></path><path d="M434.176 429.787429l22.186667-22.528c-15.018667-16.725333-33.450667-33.450667-54.613334-50.517334l-22.528 21.504c23.210667 18.090667 41.642667 35.157333 54.954667 51.541334z m237.226667 227.669333v-31.744H597.333333v-108.544h62.464v-30.378667H597.333333v-87.722666h67.242667v-31.744H471.04v31.744h93.184v226.645333h-39.936v-175.104h-31.744v175.104h-32.085333v31.744h210.944z m-265.557334-1.706667a485.888 485.888 0 0 0 65.536-53.248l-8.533333-34.474666c-10.581333 10.24-20.48 19.797333-29.696 27.989333v-140.288H354.986667v31.061333h47.104v122.197334c0 6.826667-3.072 12.629333-8.533334 17.408l12.288 29.354666z" fill="#007AFF" p-id="25532"></path></svg>
                            </span>
                          </el-tooltip>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="subject"
                        label="实验名称">
                      <template slot-scope="scope">
                        <span class="">{{scope.row._source.subject}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!groupId"
                        label="所属项目">
                      <template slot-scope="scope">
                        <span class="">{{experimentGroupIdNameMap[scope.row._source.group_id]?experimentGroupIdNameMap[scope.row._source.group_id]:'未分类实验'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        width="250"
                        label="属性">
                      <template slot-scope="scope">
                        <div style="display: flex; flex-direction: column;">
                          <span class="">创建时间：{{scope.row._source.create_time}}</span>
                          <span class="" v-if="scope.row._source.update_time">修改时间：{{scope.row._source.update_time}}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        width="100"
                        label="实验实验状态">
                      <template slot-scope="scope">
                            <span class="group_operate">{{scope.row._source.status=='0'?"待复核":scope.row._source.status=='1'?'复核通过':scope.row._source.status=='2'?'复核拒绝':scope.row._source.status=='3'?'待提交':''}}
                              	<el-tooltip v-if="isEdit=='0'&&(scope.row._source.status=='1'||scope.row._source.status=='2')&&scope.row._source.reason"  effect="dark" :content="scope.row._source.reason" placement="bottom">
									<span class="base-icon-info"></span>
								</el-tooltip>
                            </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        width="220"
                        v-if="isEdit=='0'&&groupData.archivingStatus!=1"
                        label="操作">
                      <template slot-scope="scope">
                        <template  v-if="scope.row._source.status&&scope.row._source.status=='4'">
                          <svg t="1688546377180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9029" data-spm-anchor-id="a313x.7781069.0.i40" width="50" height="50">
                            <path d="M936.999 234.579C782.773 0.151 467.589-65.027 232.933 89.043c-234.657 154.07-299.9 468.951-145.68 703.379 154.221 234.422 469.42 299.606 704.067 145.537 234.646-154.07 299.9-468.952 145.679-703.38zM768.373 903.238c-215.487 141.477-504.865 81.556-646.477-133.635C-19.7 554.326 40.281 265.236 255.666 123.764 471.158-17.703 760.532 42.218 902.138 257.398c141.604 215.18 81.722 504.368-133.765 645.84z m108.641-629.372C744.54 72.574 473.844 16.626 272.354 148.867 70.865 281.109 14.76 551.65 147.228 752.936c132.372 201.298 403.176 257.344 604.659 125 201.495-132.344 257.595-402.778 125.127-604.07zM740.467 860.685c-191.95 125.993-449.843 72.712-575.96-119.06C38.389 549.861 91.718 292.221 283.672 166.227c191.956-125.994 449.849-72.718 575.966 119.05 126.216 191.766 72.79 449.408-119.171 575.408z m-349.048-530.57c60.479-39.683 133.368-45.637 196.425-22.519l21.737-14.289c-72.387-31.946-158.883-27.68-229.984 18.942-71.1 46.627-109.23 124.308-108.636 203.375l21.748-14.387c3.772-67.053 38.232-131.438 98.71-171.122z m253.125 384.626c71.096-46.627 109.231-124.313 108.636-203.375l-21.742 14.29c-3.768 67.069-38.231 131.45-98.709 171.133-60.474 39.688-133.364 45.627-196.42 22.524l-21.747 14.386c72.384 31.937 158.887 27.67 229.982-18.958zM326.868 293.408l14.796-39.089 41.71 1.986-32.574-26.09 14.797-39.089-34.954 22.92-32.674-26.095 11.023 40.277-34.952 22.915 41.801 1.986 11.027 40.279z m-40.216 41.274l-40.617-9.824-3.077-41.665-21.95 35.513-40.611-9.916 27.01 31.943-21.946 35.518 38.629-15.874 27.111 31.845-3.178-41.669 38.629-15.871z m150.647-98.813l29.888-29.168 37.043 19.349-18.473-37.401 29.888-29.168-41.406 6.05-18.473-37.499-7.052 41.171-41.405 6.055 37.037 19.44-7.047 41.171z m124.429-5.556l39.513-13.787 25.328 33.136-0.997-41.669 39.528-13.888-40.124-12.005-0.895-41.664-23.827 34.324-40.016-12.004 25.311 33.232-23.821 34.325zM191.222 454.819l-20.456-36.407-4.866 41.465-41.015 8.138 37.933 17.459-4.866 41.466 28.403-30.651 37.932 17.459-20.456-36.407 28.403-30.758-41.012 8.236z m506.055 278.682L682.48 772.58l-41.709-1.986 32.572 26.094-14.795 39.09 34.957-22.916 32.675 26.08-11.023-40.268 34.948-22.919-41.807-1.986-11.021-40.268z m141.412-82.846l-38.635 15.874-27.111-31.85 3.178 41.674-38.629 15.875 40.617 9.818 3.076 41.66 21.947-35.514 40.622 9.922-27.017-31.943 21.952-35.516z m-251.843 140.38l-29.888 29.168-37.042-19.35 18.473 37.408-29.888 29.163 41.409-6.06 18.469 37.505 7.047-41.162 41.41-6.064-37.032-19.435 7.042-41.173z m-124.423 5.553l-39.524 13.791-25.323-33.136 0.992 41.67-39.524 13.888 40.119 12.01 0.896 41.658 23.832-34.323 40.021 11.997-25.323-33.227 23.834-34.328zM861.332 541.43l4.866-41.472-28.407 30.656-37.934-17.459 20.457 36.411-28.403 30.744 41.019-8.225 20.451 36.408 4.867-41.467 41.014-8.133-37.93-17.463z" fill="#d81e06" p-id="9030" data-spm-anchor-id="a313x.7781069.0.i39" class=""></path><path d="M375.298 584.906l-23.565-36.422-72.389 46.838c-2.72 1.76-4.606 3.483-5.663 5.164l-6.729-4.436c2.442-0.863 5.122-2.242 8.045-4.133l72.691-47.033-0.489-8.045c-0.036-2.262 0.476-3.738 1.534-4.423 1.057-0.685 3.35-0.952 6.875-0.805l10.082 0.339c3.093 0.142 5.047 0.844 5.861 2.102 0.816 1.262-0.338 3.9-3.453 7.916l21.414 33.097c1.826 2.821 3.213 4.856 4.16 6.099l2.596 3.68c0.652 1.01 0.71 2.258 0.173 3.748-0.535 1.492-2.025 3.883-4.468 7.178-2.441 3.296-3.99 5.154-4.645 5.578-0.656 0.424-1.438-0.068-2.352-1.48l-6.159-9.521-62.716 40.579 31.583 48.813c1.955 3.022 3.978 4.606 6.075 4.751 2.095 0.146 7.721-2.424 16.881-7.707 9.158-5.282 17.844-10.58 26.057-15.895 8.21-5.312 15.744-10.4 22.602-15.266 6.855-4.865 10.867-7.998 12.036-9.396 1.167-1.396 1.841-3.119 2.019-5.164s-0.195-4.662-1.115-7.855c-0.921-3.188-2.475-7.188-4.653-11.996-2.183-4.806-5.281-11.195-9.298-19.174l4.08-2.641c5.826 9.666 10.959 16.887 15.404 21.654 4.445 4.772 8.701 6.986 12.766 6.641 2.334-0.367 3.828-0.048 4.48 0.961 0.65 1.006 0.856 4.089 0.622 9.246-0.239 5.154-1.651 9.322-4.241 12.498-2.59 3.177-8.883 8.139-18.877 14.894-9.995 6.753-22.449 14.954-37.359 24.601-14.911 9.648-25.297 15.796-31.157 18.445-5.864 2.648-10.981 3.96-15.356 3.934-4.379-0.027-8.717-3.365-13.02-10.014l-39.014-60.3c-4.434-6.851-8.234-12.394-11.405-16.632 7.964-3.15 13.921-5.326 17.864-6.521 3.944-1.191 6.145-1.436 6.6-0.732 0.587 0.907-0.498 3.539-3.254 7.895l6.16 9.521 62.717-40.581zM424.673 508.795c-2.935-4.534-5.643-8.497-8.125-11.895 4.111-1.374 9.105-2.709 14.982-4.013 5.877-1.299 9.107-1.497 9.694-0.591 0.587 0.907-0.517 3.624-3.308 8.143l37.549 58.032c3.26 5.039 5.591 8.533 6.996 10.48l3.92 5.396c0.391 0.605 0.244 1.594-0.44 2.965-0.685 1.375-2.079 3.525-4.183 6.459-2.104 2.935-3.533 4.643-4.289 5.132s-1.459 0.231-2.111-0.777l-4.587-7.752c-1.726-2.884-4.542-7.351-8.454-13.396l-37.644-58.183z m11.219-46.279c9.4-3.365 15.635-5.326 18.704-5.885 3.07-0.556 4.817-0.507 5.24 0.147 0.425 0.657 0.175 1.816-0.747 3.485-0.923 1.669-1.183 3.09-0.782 4.258 0.4 1.172 1.267 2.899 2.601 5.178 22.009 35.787 35.414 58.877 40.215 69.277 4.8 10.4 7.744 20.254 8.83 29.553 1.088 9.303 0.25 18.669-2.507 28.101-2.762 9.431-7.146 19.663-13.153 30.7l-3.076-1.44c5.513-16.001 7.91-29.526 7.197-40.567-0.712-11.043-3.618-22.491-8.715-34.345-5.096-11.852-16.02-30.725-32.774-56.619-5.998-9.268-13.01-19.883-21.033-31.843z m114.541 24.938l-38.536 24.934c-1.813 1.173-3.538 3.147-5.175 5.921l-6.826-4.587c2.442-0.864 5.121-2.243 8.045-4.134l40.047-25.912-23.564-36.42-42.013 27.183c-2.72 1.76-4.606 3.483-5.662 5.165l-7.12-5.04c2.442-0.864 5.121-2.242 8.045-4.133l41.861-27.086 0.285-9.832c-0.047-1.396 0.23-2.293 0.834-2.685 0.907-0.587 4.229-0.806 9.971-0.662 5.739 0.146 9.348 0.313 10.828 0.498 1.479 0.189 2.496 0.71 3.049 1.565 0.555 0.857-0.756 4.026-3.926 9.507l49.38 76.318c2.934 4.533 5.134 7.826 6.604 9.876l3.965 5.796c0.391 0.605 0.533 1.156 0.427 1.654-0.106 0.497-0.714 1.711-1.823 3.645-1.108 1.93-2.485 4-4.129 6.209-1.646 2.208-2.77 3.507-3.374 3.897-0.604 0.392-1.429-0.221-2.472-1.831l-8.115-12.543-49.719 32.17c-2.721 1.761-4.608 3.48-5.663 5.164l-6.925-4.738c2.441-0.863 5.121-2.24 8.045-4.133l51.23-33.147-27.574-42.619zM607.567 406.107l2.268-1.467 0.027-9.236c0.061-1.895 0.542-3.138 1.449-3.725 0.906-0.586 4.213-0.223 9.92 1.085 5.706 1.313 8.822 2.368 9.342 3.173 0.523 0.808-0.176 1.83-2.088 3.067l-17.984 11.636 10.756 16.624c8.244-1.616 14.883-2.233 19.922-1.849 5.037 0.386 8.421 1.915 10.146 4.583 1.729 2.67 2.403 5.702 2.023 9.09-0.379 3.391-1.25 5.525-2.609 6.405-1.359 0.879-2.627 1.023-3.801 0.422-1.173-0.599-2.83-1.777-4.969-3.538-6.287-5.079-12.247-8.656-17.877-10.73l44.393 68.611c0.717 1.106 0.852 2.199 0.405 3.275-0.45 1.075-1.724 2.97-3.823 5.69-2.102 2.716-3.656 4.402-4.662 5.054-0.506 0.326-1.018 0.084-1.538-0.722l-4.294-7.298a390.422 390.422 0 0 0-8.4-13.645l-30.02-46.396c1.648 8.511 2.527 16.663 2.636 24.451 0.11 7.792-0.781 18.729-2.671 32.815l-4.596 0.187c1.195-24.213-4.332-51.868-16.587-82.958l-12.392 8.018c-2.621 1.696-4.623 3.35-6.01 4.96l-6.48-4.383c2.443-0.863 5.121-2.242 8.045-4.134l17.229-11.147-12.125-18.739c-5.605-8.664-9.473-14.309-11.602-16.935 5.221-2.091 9.622-3.686 13.197-4.787 3.577-1.098 5.807-1.682 6.689-1.755 0.884-0.069 1.456 0.097 1.716 0.499 0.522 0.808-0.396 3.257-2.747 7.351l17.112 26.448z m1.584-35.327c21.944 1.667 35.135 5.925 39.566 12.776 1.695 2.621 2.436 5.643 2.223 9.067-0.215 3.428-1.732 6.052-4.552 7.876-1.208 0.782-2.333 0.866-3.374 0.253-1.039-0.613-3.435-3.208-7.182-7.787-3.749-4.577-7.653-8.234-11.708-10.971-4.058-2.734-9.179-5.457-15.365-8.174l0.392-3.04z m58.287 27.461l-30.801-47.604c-3.911-6.045-6.275-9.587-7.094-10.632 13.689-5.567 21.058-7.548 22.1-5.938 0.719 1.11-0.166 3.611-2.648 7.502l31.289 48.36 15.869-10.267-0.009-10.285c0.111-0.93 0.419-1.558 0.925-1.884 0.604-0.391 4.211-0.615 10.818-0.676 6.608-0.058 10.189 0.341 10.742 1.196 0.555 0.857-0.316 3.602-2.609 8.228l33.344 51.533c4.433 6.85 7.09 10.85 7.974 11.993l2.596 3.68c0.521 0.805 0.473 1.838-0.142 3.094-0.618 1.257-2.012 3.301-4.179 6.134-2.171 2.832-3.809 4.608-4.915 5.324-0.707 0.458-1.549-0.071-2.525-1.582l-6.846-10.579-56.973 36.863c-2.018 1.305-3.484 2.682-4.4 4.134l-6.668-5.334c2.173-0.836 4.32-1.939 6.437-3.308l58.183-37.646-17.601-27.202-48.964 31.681c-1.915 1.239-3.432 2.65-4.551 4.231l-6.518-5.432c2.075-0.769 4.22-1.872 6.437-3.306l50.173-32.463-16.133-24.936-50.777 32.854c-2.018 1.305-3.534 2.715-4.553 4.231l-6.027-4.676c2.075-0.77 4.22-1.872 6.437-3.307l21.609-13.981z m4.741-72.53c15.059-1.023 23.045-0.832 23.957 0.579 0.457 0.706 0.027 1.59-1.283 2.653-1.314 1.064-2.135 2.061-2.464 2.987-0.329 0.929-0.729 2.904-1.204 5.924-3.131 19.465-6.07 34.801-8.82 46.012l-2.941-0.24c-0.331-24.367-2.747-43.673-7.245-57.915z" p-id="9031" data-spm-anchor-id="a313x.7781069.0.i37" class="" fill="#d81e06"></path></svg>
                        </template>
                        <template v-else>
                          <el-button   size="mini" @click="$router.push('/manager/experiment/edit/'+scope.row._source.group_id+'/'+scope.row._source.form_template_id+'/'+scope.row._source.uuid+'/0')" type="primary">编辑</el-button>
                          <el-button v-if="groupId!=UNSORTED_ID&&scope.row._source.group_id!=UNSORTED_ID"  size="mini" @click="goExperimentSubmit(scope.row._source)" type="warning">提交</el-button>
                          <el-button    size="mini" @click="deleteExperiment(scope.row._source)" type="info">删除</el-button>
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="experiment_id"
                    label="实验编号">
                  <template slot-scope="scope">
                    <el-tooltip content="查看实验详情" placement="bottom">
                      <el-link style='color:#409EFF'  @click="$router.push('/manager/experiment/detail/'+scope.row.uuid+'/'+isEdit)" :underline="false">{{scope.row.experiment_id}}</el-link>
                    </el-tooltip>
                    <template v-if="scope.row.txid">
                      <el-tooltip content="查看存证证书" placement="top">
                        <span @click="loadCertificate(scope.row.txid)" class="loadCertificate">
                          <svg t="1712046094491"  style="vertical-align: middle;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25529" width="22" height="22"><path d="M0 0m195.047619 0l633.904762 0q195.047619 0 195.047619 195.047619l0 633.904762q0 195.047619-195.047619 195.047619l-633.904762 0q-195.047619 0-195.047619-195.047619l0-633.904762q0-195.047619 195.047619-195.047619Z" fill="#007AFF" p-id="25530"></path><path d="M219.233524 288.621714v245.662476c0 161.962667 132.510476 295.521524 294.473143 294.473143 160.694857-1.048381 290.669714-131.584 290.669714-292.571428V288.621714a45.056 45.056 0 0 0-45.007238-45.007238H264.240762a45.056 45.056 0 0 0-45.007238 45.007238z" fill="#FFFFFF" p-id="25531"></path><path d="M434.176 429.787429l22.186667-22.528c-15.018667-16.725333-33.450667-33.450667-54.613334-50.517334l-22.528 21.504c23.210667 18.090667 41.642667 35.157333 54.954667 51.541334z m237.226667 227.669333v-31.744H597.333333v-108.544h62.464v-30.378667H597.333333v-87.722666h67.242667v-31.744H471.04v31.744h93.184v226.645333h-39.936v-175.104h-31.744v175.104h-32.085333v31.744h210.944z m-265.557334-1.706667a485.888 485.888 0 0 0 65.536-53.248l-8.533333-34.474666c-10.581333 10.24-20.48 19.797333-29.696 27.989333v-140.288H354.986667v31.061333h47.104v122.197334c0 6.826667-3.072 12.629333-8.533334 17.408l12.288 29.354666z" fill="#007AFF" p-id="25532"></path></svg>
                          </span>
                        </el-tooltip>
                      </template>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="subject"
                    label="实验名称">
                  <template slot-scope="scope">
                    <span class="">{{scope.row.subject}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="!groupId"
                    label="所属项目">
                  <template slot-scope="scope">
                    <span class="">{{experimentGroupIdNameMap[scope.row.group_id]?experimentGroupIdNameMap[scope.row.group_id]:'未分类实验'}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="250"
                    label="属性">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column;">
                      <span class="">创建时间：{{scope.row.create_time}}</span>
                      <span class="" v-if="scope.row.update_time">修改时间：{{scope.row.update_time}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    label="实验状态">
                  <template slot-scope="scope">
                            <span class="group_operate">{{scope.row.status=='0'?"待复核":scope.row.status=='1'?'复核通过':scope.row.status=='2'?'复核拒绝':scope.row.status=='3'?'待提交':scope.row.status=='4'?'已归档':''}}
                              	<el-tooltip v-if="isEdit=='0'&&(scope.row.status=='1'||scope.row.status=='2')&&scope.row.reason"  effect="dark" :content="scope.row.reason" placement="bottom">
									<span class="base-icon-info"></span>
								</el-tooltip>
                            </span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="220"
                    v-if="isEdit=='0'&&groupData.archivingStatus!=1"
                    label="操作">
                  <template slot-scope="scope">
                    <template  v-if="scope.row.status&&scope.row.status=='4'">
                      <svg t="1688546377180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9029" data-spm-anchor-id="a313x.7781069.0.i40" width="50" height="50">
                        <path d="M936.999 234.579C782.773 0.151 467.589-65.027 232.933 89.043c-234.657 154.07-299.9 468.951-145.68 703.379 154.221 234.422 469.42 299.606 704.067 145.537 234.646-154.07 299.9-468.952 145.679-703.38zM768.373 903.238c-215.487 141.477-504.865 81.556-646.477-133.635C-19.7 554.326 40.281 265.236 255.666 123.764 471.158-17.703 760.532 42.218 902.138 257.398c141.604 215.18 81.722 504.368-133.765 645.84z m108.641-629.372C744.54 72.574 473.844 16.626 272.354 148.867 70.865 281.109 14.76 551.65 147.228 752.936c132.372 201.298 403.176 257.344 604.659 125 201.495-132.344 257.595-402.778 125.127-604.07zM740.467 860.685c-191.95 125.993-449.843 72.712-575.96-119.06C38.389 549.861 91.718 292.221 283.672 166.227c191.956-125.994 449.849-72.718 575.966 119.05 126.216 191.766 72.79 449.408-119.171 575.408z m-349.048-530.57c60.479-39.683 133.368-45.637 196.425-22.519l21.737-14.289c-72.387-31.946-158.883-27.68-229.984 18.942-71.1 46.627-109.23 124.308-108.636 203.375l21.748-14.387c3.772-67.053 38.232-131.438 98.71-171.122z m253.125 384.626c71.096-46.627 109.231-124.313 108.636-203.375l-21.742 14.29c-3.768 67.069-38.231 131.45-98.709 171.133-60.474 39.688-133.364 45.627-196.42 22.524l-21.747 14.386c72.384 31.937 158.887 27.67 229.982-18.958zM326.868 293.408l14.796-39.089 41.71 1.986-32.574-26.09 14.797-39.089-34.954 22.92-32.674-26.095 11.023 40.277-34.952 22.915 41.801 1.986 11.027 40.279z m-40.216 41.274l-40.617-9.824-3.077-41.665-21.95 35.513-40.611-9.916 27.01 31.943-21.946 35.518 38.629-15.874 27.111 31.845-3.178-41.669 38.629-15.871z m150.647-98.813l29.888-29.168 37.043 19.349-18.473-37.401 29.888-29.168-41.406 6.05-18.473-37.499-7.052 41.171-41.405 6.055 37.037 19.44-7.047 41.171z m124.429-5.556l39.513-13.787 25.328 33.136-0.997-41.669 39.528-13.888-40.124-12.005-0.895-41.664-23.827 34.324-40.016-12.004 25.311 33.232-23.821 34.325zM191.222 454.819l-20.456-36.407-4.866 41.465-41.015 8.138 37.933 17.459-4.866 41.466 28.403-30.651 37.932 17.459-20.456-36.407 28.403-30.758-41.012 8.236z m506.055 278.682L682.48 772.58l-41.709-1.986 32.572 26.094-14.795 39.09 34.957-22.916 32.675 26.08-11.023-40.268 34.948-22.919-41.807-1.986-11.021-40.268z m141.412-82.846l-38.635 15.874-27.111-31.85 3.178 41.674-38.629 15.875 40.617 9.818 3.076 41.66 21.947-35.514 40.622 9.922-27.017-31.943 21.952-35.516z m-251.843 140.38l-29.888 29.168-37.042-19.35 18.473 37.408-29.888 29.163 41.409-6.06 18.469 37.505 7.047-41.162 41.41-6.064-37.032-19.435 7.042-41.173z m-124.423 5.553l-39.524 13.791-25.323-33.136 0.992 41.67-39.524 13.888 40.119 12.01 0.896 41.658 23.832-34.323 40.021 11.997-25.323-33.227 23.834-34.328zM861.332 541.43l4.866-41.472-28.407 30.656-37.934-17.459 20.457 36.411-28.403 30.744 41.019-8.225 20.451 36.408 4.867-41.467 41.014-8.133-37.93-17.463z" fill="#d81e06" p-id="9030" data-spm-anchor-id="a313x.7781069.0.i39" class=""></path><path d="M375.298 584.906l-23.565-36.422-72.389 46.838c-2.72 1.76-4.606 3.483-5.663 5.164l-6.729-4.436c2.442-0.863 5.122-2.242 8.045-4.133l72.691-47.033-0.489-8.045c-0.036-2.262 0.476-3.738 1.534-4.423 1.057-0.685 3.35-0.952 6.875-0.805l10.082 0.339c3.093 0.142 5.047 0.844 5.861 2.102 0.816 1.262-0.338 3.9-3.453 7.916l21.414 33.097c1.826 2.821 3.213 4.856 4.16 6.099l2.596 3.68c0.652 1.01 0.71 2.258 0.173 3.748-0.535 1.492-2.025 3.883-4.468 7.178-2.441 3.296-3.99 5.154-4.645 5.578-0.656 0.424-1.438-0.068-2.352-1.48l-6.159-9.521-62.716 40.579 31.583 48.813c1.955 3.022 3.978 4.606 6.075 4.751 2.095 0.146 7.721-2.424 16.881-7.707 9.158-5.282 17.844-10.58 26.057-15.895 8.21-5.312 15.744-10.4 22.602-15.266 6.855-4.865 10.867-7.998 12.036-9.396 1.167-1.396 1.841-3.119 2.019-5.164s-0.195-4.662-1.115-7.855c-0.921-3.188-2.475-7.188-4.653-11.996-2.183-4.806-5.281-11.195-9.298-19.174l4.08-2.641c5.826 9.666 10.959 16.887 15.404 21.654 4.445 4.772 8.701 6.986 12.766 6.641 2.334-0.367 3.828-0.048 4.48 0.961 0.65 1.006 0.856 4.089 0.622 9.246-0.239 5.154-1.651 9.322-4.241 12.498-2.59 3.177-8.883 8.139-18.877 14.894-9.995 6.753-22.449 14.954-37.359 24.601-14.911 9.648-25.297 15.796-31.157 18.445-5.864 2.648-10.981 3.96-15.356 3.934-4.379-0.027-8.717-3.365-13.02-10.014l-39.014-60.3c-4.434-6.851-8.234-12.394-11.405-16.632 7.964-3.15 13.921-5.326 17.864-6.521 3.944-1.191 6.145-1.436 6.6-0.732 0.587 0.907-0.498 3.539-3.254 7.895l6.16 9.521 62.717-40.581zM424.673 508.795c-2.935-4.534-5.643-8.497-8.125-11.895 4.111-1.374 9.105-2.709 14.982-4.013 5.877-1.299 9.107-1.497 9.694-0.591 0.587 0.907-0.517 3.624-3.308 8.143l37.549 58.032c3.26 5.039 5.591 8.533 6.996 10.48l3.92 5.396c0.391 0.605 0.244 1.594-0.44 2.965-0.685 1.375-2.079 3.525-4.183 6.459-2.104 2.935-3.533 4.643-4.289 5.132s-1.459 0.231-2.111-0.777l-4.587-7.752c-1.726-2.884-4.542-7.351-8.454-13.396l-37.644-58.183z m11.219-46.279c9.4-3.365 15.635-5.326 18.704-5.885 3.07-0.556 4.817-0.507 5.24 0.147 0.425 0.657 0.175 1.816-0.747 3.485-0.923 1.669-1.183 3.09-0.782 4.258 0.4 1.172 1.267 2.899 2.601 5.178 22.009 35.787 35.414 58.877 40.215 69.277 4.8 10.4 7.744 20.254 8.83 29.553 1.088 9.303 0.25 18.669-2.507 28.101-2.762 9.431-7.146 19.663-13.153 30.7l-3.076-1.44c5.513-16.001 7.91-29.526 7.197-40.567-0.712-11.043-3.618-22.491-8.715-34.345-5.096-11.852-16.02-30.725-32.774-56.619-5.998-9.268-13.01-19.883-21.033-31.843z m114.541 24.938l-38.536 24.934c-1.813 1.173-3.538 3.147-5.175 5.921l-6.826-4.587c2.442-0.864 5.121-2.243 8.045-4.134l40.047-25.912-23.564-36.42-42.013 27.183c-2.72 1.76-4.606 3.483-5.662 5.165l-7.12-5.04c2.442-0.864 5.121-2.242 8.045-4.133l41.861-27.086 0.285-9.832c-0.047-1.396 0.23-2.293 0.834-2.685 0.907-0.587 4.229-0.806 9.971-0.662 5.739 0.146 9.348 0.313 10.828 0.498 1.479 0.189 2.496 0.71 3.049 1.565 0.555 0.857-0.756 4.026-3.926 9.507l49.38 76.318c2.934 4.533 5.134 7.826 6.604 9.876l3.965 5.796c0.391 0.605 0.533 1.156 0.427 1.654-0.106 0.497-0.714 1.711-1.823 3.645-1.108 1.93-2.485 4-4.129 6.209-1.646 2.208-2.77 3.507-3.374 3.897-0.604 0.392-1.429-0.221-2.472-1.831l-8.115-12.543-49.719 32.17c-2.721 1.761-4.608 3.48-5.663 5.164l-6.925-4.738c2.441-0.863 5.121-2.24 8.045-4.133l51.23-33.147-27.574-42.619zM607.567 406.107l2.268-1.467 0.027-9.236c0.061-1.895 0.542-3.138 1.449-3.725 0.906-0.586 4.213-0.223 9.92 1.085 5.706 1.313 8.822 2.368 9.342 3.173 0.523 0.808-0.176 1.83-2.088 3.067l-17.984 11.636 10.756 16.624c8.244-1.616 14.883-2.233 19.922-1.849 5.037 0.386 8.421 1.915 10.146 4.583 1.729 2.67 2.403 5.702 2.023 9.09-0.379 3.391-1.25 5.525-2.609 6.405-1.359 0.879-2.627 1.023-3.801 0.422-1.173-0.599-2.83-1.777-4.969-3.538-6.287-5.079-12.247-8.656-17.877-10.73l44.393 68.611c0.717 1.106 0.852 2.199 0.405 3.275-0.45 1.075-1.724 2.97-3.823 5.69-2.102 2.716-3.656 4.402-4.662 5.054-0.506 0.326-1.018 0.084-1.538-0.722l-4.294-7.298a390.422 390.422 0 0 0-8.4-13.645l-30.02-46.396c1.648 8.511 2.527 16.663 2.636 24.451 0.11 7.792-0.781 18.729-2.671 32.815l-4.596 0.187c1.195-24.213-4.332-51.868-16.587-82.958l-12.392 8.018c-2.621 1.696-4.623 3.35-6.01 4.96l-6.48-4.383c2.443-0.863 5.121-2.242 8.045-4.134l17.229-11.147-12.125-18.739c-5.605-8.664-9.473-14.309-11.602-16.935 5.221-2.091 9.622-3.686 13.197-4.787 3.577-1.098 5.807-1.682 6.689-1.755 0.884-0.069 1.456 0.097 1.716 0.499 0.522 0.808-0.396 3.257-2.747 7.351l17.112 26.448z m1.584-35.327c21.944 1.667 35.135 5.925 39.566 12.776 1.695 2.621 2.436 5.643 2.223 9.067-0.215 3.428-1.732 6.052-4.552 7.876-1.208 0.782-2.333 0.866-3.374 0.253-1.039-0.613-3.435-3.208-7.182-7.787-3.749-4.577-7.653-8.234-11.708-10.971-4.058-2.734-9.179-5.457-15.365-8.174l0.392-3.04z m58.287 27.461l-30.801-47.604c-3.911-6.045-6.275-9.587-7.094-10.632 13.689-5.567 21.058-7.548 22.1-5.938 0.719 1.11-0.166 3.611-2.648 7.502l31.289 48.36 15.869-10.267-0.009-10.285c0.111-0.93 0.419-1.558 0.925-1.884 0.604-0.391 4.211-0.615 10.818-0.676 6.608-0.058 10.189 0.341 10.742 1.196 0.555 0.857-0.316 3.602-2.609 8.228l33.344 51.533c4.433 6.85 7.09 10.85 7.974 11.993l2.596 3.68c0.521 0.805 0.473 1.838-0.142 3.094-0.618 1.257-2.012 3.301-4.179 6.134-2.171 2.832-3.809 4.608-4.915 5.324-0.707 0.458-1.549-0.071-2.525-1.582l-6.846-10.579-56.973 36.863c-2.018 1.305-3.484 2.682-4.4 4.134l-6.668-5.334c2.173-0.836 4.32-1.939 6.437-3.308l58.183-37.646-17.601-27.202-48.964 31.681c-1.915 1.239-3.432 2.65-4.551 4.231l-6.518-5.432c2.075-0.769 4.22-1.872 6.437-3.306l50.173-32.463-16.133-24.936-50.777 32.854c-2.018 1.305-3.534 2.715-4.553 4.231l-6.027-4.676c2.075-0.77 4.22-1.872 6.437-3.307l21.609-13.981z m4.741-72.53c15.059-1.023 23.045-0.832 23.957 0.579 0.457 0.706 0.027 1.59-1.283 2.653-1.314 1.064-2.135 2.061-2.464 2.987-0.329 0.929-0.729 2.904-1.204 5.924-3.131 19.465-6.07 34.801-8.82 46.012l-2.941-0.24c-0.331-24.367-2.747-43.673-7.245-57.915z" p-id="9031" data-spm-anchor-id="a313x.7781069.0.i37" class="" fill="#d81e06"></path></svg>
                    </template>
                    <template v-else>
                      <el-button  size="mini" @click="$router.push('/manager/experiment/edit/'+scope.row.group_id+'/'+scope.row.form_template_id+'/'+scope.row.uuid+'/0')" type="primary">编辑</el-button>
                      <el-button v-if="groupId!=UNSORTED_ID&&scope.row.group_id!=UNSORTED_ID"  size="mini" @click="goExperimentSubmit(scope.row)" type="warning">提交</el-button>
                      <el-button    size="mini" @click="deleteExperiment(scope.row)" type="info">删除</el-button>
                      <el-button  class="btnInfo" size="mini" @click="$router.push('/manager/experimentChild/edit/'+scope.row.group_id+'/'+scope.row.form_template_id+'/1/0/'+scope.row.uuid)" type="primary" > 新建子实验</el-button>
                      <el-button   size="mini" @click="toUpdateProject(scope.row.uuid)" type="warning">更换项目</el-button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
                <div class="page-warp">
                    <el-pagination
                        @current-change="listExperiment"
                        :hide-on-single-page="total<pageSize"
                        background
                        layout="total,prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page.sync="page"
                    ></el-pagination>
                </div>
            </x-card>
        </x-content>
      <app-dialog  ref="userSignatureDialog" dialogTitle="验证签名密码" originTitle staticDialog width="600px">
        <div>
          <el-form >
            <el-form-item  v-model="password">
              <el-input show-password  v-model="password" placeholder="请输入签名密码"></el-input>
            </el-form-item>
            <div class="save_btn_warp">
              <el-button type="primary" @click="verify" style="width:200px;" size="medium" :loading="saveLoading">确定</el-button>
            </div>
          </el-form>
        </div>
      </app-dialog>
        <app-dialog  ref="addDialog" dialogTitle="新建实验" originTitle staticDialog width="500px">
            <el-form ref="form" label-position="top" :rules="rules" :model="form">
				<el-form-item prop="project" >
					<el-select class="Width-100" v-model="form.project" filterable clearable placeholder="请选择项目">
                        <el-option
                            v-for="(item,key) in projectList"
                            v-if="item.archivingStatus!=1"
                            :key="item.id"
                            :label="item.groupName"
                            :value="item.id+'$$$'+item.formTemplateId">
                        </el-option>
                    </el-select>
				</el-form-item>
            </el-form>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:50%;" size="medium" @click="goExperimentEdit">确定</el-button>
            </div>
        </app-dialog>
        <app-dialog  ref="dissolutionDialog" dialogTitle="转让项目" originTitle staticDialog width="600px">
            <div class="save_btn_warp">
                <el-button type="primary" style="width:200px;" size="medium" :loading="saveLoading">确定</el-button>
            </div>
        </app-dialog>
        <app-dialog ref="shareDialog" dialogTitle="分享实验" @hide="closeShare" originTitle staticDialog width="600px">
            <div style="margin-top:15px;">
                <span>请选择要分享的成员:</span>
                <el-checkbox-group v-model="shareIdList">
                  <el-checkbox  style="margin-top:10px;" v-for="group in shareUserList" :label="group.userId?group.userId:group.id">{{group.userName?group.userName:group.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:50%;" size="medium" @click="shareExperiment">分享</el-button>
            </div>
        </app-dialog>
      <app-dialog ref="addDia" dialogTitle="签名" originTitle staticDialog width="600px">
        <el-form :model="userSignature" ref="userSignatureForm" >
        <div style="display: flex;justify-content: center;">
          <vue-esign
              ref="esign"
              class="mySign"
              :width="600"
              :height="300"
              :isCrop="false"
              :lineWidth="6"
              lineColor="#000000"
              bgColor.sync="bgColor"
          />
        </div>
        <el-form-item >
          <el-input v-model="userSignature.password" show-password @clear="userSignature.password = ''" placeholder="请输入签名密码，密码格式为6位数字，下次输入密码即可完成电子签名"></el-input>
        </el-form-item>
        </el-form>
        <div class="save_btn_warp">
          <el-button type="warning" style="width:20%;" size="medium" @click="resetSign">清空签名</el-button>
          <el-button type="primary" style="width:20%;" size="medium" @click="saveSignImg">确定</el-button>
        </div>
      </app-dialog>
        <app-dialog ref="copyDialog" dialogTitle="复制实验" originTitle staticDialog width="500px">
          <el-select class="Width-100" v-model="projectId" filterable clearable placeholder="请选择项目">
                        <el-option
                            v-for="(item,key) in projectData"
                            :key="item.id"
                            :label="item.groupName"
                            :value="item.id">
                        </el-option>
                    </el-select>
          <div class="save_btn_warp">
              <el-button type="primary" style="width:50%;" size="medium" @click="goCopyExperiment">确定</el-button>
          </div>
      </app-dialog>
      <app-dialog ref="updateProjectDialog" dialogTitle="更改实验归属" originTitle staticDialog width="500px">
          <el-select class="Width-100" v-model="updateProjectForm.projectId" filterable clearable placeholder="请选择项目">
                        <el-option
                            v-for="(item,key) in projectData"
                            :key="item.id"
                            :label="item.groupName"
                            :value="item.id">
                        </el-option>
                    </el-select>
          <div class="save_btn_warp">
              <el-button type="primary" style="width:50%;" size="medium" @click="updateProject">确定</el-button>
          </div>
      </app-dialog>
      <app-dialog ref="certificateUrlDialog" class="Previewdialog" dialogTitle="实验记录存证证明" width="800px"  originTitle staticDialog >
        <div style='margin-bottom: 15px;text-align: right;'>
          <a style='color:#409EFF;font-size: 16px;font-weight: bold;' :href="HKY_DOWLOAD_URL+certificateUrl">
             存证证明下载 <i class="el-icon-download" style="font-weight: bold;"></i></a></div>
            <iframe :src="'/static/pdf/web/viewer.html?file=' + certificatePrivewUrl + '&.pdf '"
						style="width: 100%; height: 90vh; border: 0px"></iframe>
  
      </app-dialog>
    </div>
</template>
<script>
import {
  GetGroupById,
  GetMyProjectList,
  GetMyProjectData,
  GetAllGroupUser,
  GetShareList, ShareExperiment
} from "@/service/user"
    import {Delete,ExportExcel,ExportWordOrPdf,Submit,TypeList,UpdateProjectId,GetCertificate} from "@/service/experiment";
    import {GetSignature, SignatureSave, Verify} from "@/service/userSignature";
    export default {
        name:'ExperimentManage',
        data(){
            return {
                loading:false,
                saveLoading:false,
                savePermissionLoading:false,
                page:1,
                total:0,
                pageSize:10,
                experimentPage:1,
                experimenTotal:0,
                experimenPageSize:10,
                searchText:"",
                sortType:'desc',
                sort:'create_time',
                certificateUrl:'',
                certificatePrivewUrl:'',
                experimentList:[],
                shareUserList:[],
                isOpenAll:true,
                formItem:{
                  projectId:'',
                  name:'',
                  type:'',
                  remarks:'',
                },
                form:{
                    note:'',
                    formTemplate:""
                },
                rules:{
                    project:[{required:true,message:'请选择项目',trigger:'change'}],
                },
                noteList:[],
                noteMap:{},
                formTemplateMap:{},
                noteIdGroupIdMap:{},
                groupId:'',
                projectId:'',
                showGroupId:'',
                noteObj:{},
                experiment_show:'my',
                sortOption: [{
                    value: 'create_time',
                    label: '创建时间'
                    }, {
                    value: 'update_time',
                    label: '修改时间'
                    }, {
                    value: 'experiment_id',
                    label: '实验编号'
                    }],
             searchOption: [{
                value: '1',
                label: '父实验'
              }, {
                value: '2',
                label: '子实验'
              }],
                searchType:'1',
                sortTypeHtml:' 降序排序<i class="el-icon-sort-down"></i>',
                selectExperiment:[],
                isEdit:"0",
                //分享
                groupObj:{},
                groupList:[],
                projectList:[],
                checkGroupList:[],
                groupIdUserMap:{},
                checkShareUserList:[],
                groupIdNameMap:{},
                //shareList:{},
                experimentGroupIdList:[],
                experimentGroupIdNameMap:{},
                selectGroupId:"",
                userSignature:{},
                password:'',
                uuid:'',
                noteId:'',
                shareList:[],
              shareIdList:[],
              formTemplateId:'',
              projectData:[],
              currGroupName:'',
              // 这里是从后端获取的Map数据
              projectTypeList:[],
              projectTypeDialogTitle:'',
              experimentSelect:{},
              experimentParentList:[],
              experimentMap:{},
              groupData:{},
              updateProjectForm:{
                uuid:'',
                projectId:''
              }

            }
        },
        created(){
            this.groupId = this.$route.params.groupId || '';
            if(this.groupId =='1'){
                this.groupId = ''
                this.experiment_show == 'my'

            }else{
                //代表是项目管理的跳转，去除查询未提交及不展示操作列
                if(this.groupId.split("_").length>1){
                     this.isEdit = '2'
                    this.groupId=this.groupId.split("_")[0]
                    this.noteId=this.groupId
                    this.selectGroupId=''
                }else{
                    //this.groupId=this.groupId
                    this.noteId=''
                    this.isEdit="0"
                    this.selectGroupId=this.groupId

                }
                this.showGroupId = this.groupId
                /**this.showGroupId = this.groupId
               this.noteId=this.groupId
                if(this.groupId==this.UNSORTED_ID){
                    //this.isEdit = '0'
                    this.noteId=''
                }*/
                this.experiment_show = this.groupId
            }
            //this.listExperiment();
            this.getMyProjectList();
            this.getMyProjectData();
            this.$nextTick(() => {
                if(this.groupId){
                    GetGroupById(this.groupId).then(e => {
                        let data = this.APIParse(e);
                        this.groupData=data;
                        this.currGroupName=data.groupName
                        this.formTemplateId=data.formTemplateId
                    })
                }
            });
        },
        watch:{
			'$route.params.groupId':{
				handler:function (newVal){
                    if(newVal){
                        this.groupId=newVal
                        if(this.groupId =='1'){
                            this.groupId = ''
                            this.experiment_show == 'my'
                            this.selectGroupId=''
                            this.noteId=''
                            this.formTemplateId=''

                        }else{
                            if(this.groupId.split("_").length>1){
                                this.isEdit = '2'
                                this.groupId=this.groupId.split("_")[0]
                                this.noteId=this.groupId
                                this.selectGroupId=''
                            }else{
                                //this.groupId=this.groupId
                                this.noteId=''
                                this.isEdit="0"
                               this.selectGroupId=this.groupId

                            }
                            this.$nextTick(() => {
				            if(this.groupId){
                                GetGroupById(this.groupId).then(e => {
                                    let data = this.APIParse(e);
                                    this.currGroupName=data.groupName
                                    this.formTemplateId=data.formTemplateId
                                })
                            }
			            });
                        this.experiment_show = this.groupId
                        }
                    }else{
                         this.groupId = ''
                         this.noteId=''
                         this.experiment_show == 'my'
                         this.selectGroupId=''
                         this.formTemplateId=''

                    }
                    this.page=1
                     this.listExperiment();

				},
				immediate:true
			}
		},
        methods:{
          search() {
			        	this.page = 1;
			        	this.listExperiment();
		    	},
            changeSortType(){
                if(this.sortType=='desc'){
                    this.sortType = 'asc';
                    this.sortTypeHtml = ' 升序排序<i class="el-icon-sort-up"></i>'
                    this.listExperiment();
                    return
                }
                if(this.sortType=='asc'){
                    this.sortType = 'desc';
                    this.sortTypeHtml = ' 降序排序<i class="el-icon-sort-down"></i>'
                    this.listExperiment();
                    return
                }
            },
            getMyProjectList(){
                GetMyProjectList().then(e => {
                    let data = this.APIParse(e);
                    this.projectList = data;
                    
                    data.forEach(item => {
                      this.$set(this.experimentGroupIdNameMap,item.id,item.groupName)
                    })

                })
            },
            getMyProjectData(){
                GetMyProjectData().then(e => {
                let data = this.APIParse(e);
                this.projectData = data;
                })
            },
            newExperiment(uuid){
              this.$router.push('/manager/experimentChild/edit/'+this.groupId+'/'+this.formTemplateId+'/1/0'+'/'+uuid)
            },
            openDialog(){
                //如果是某个项目下 直接新建
                if(this.groupId&&this.formTemplateId){
                    this.$router.push('/manager/experiment/edit/'+this.groupId+'/'+this.formTemplateId+'/1/0')
                }else{
                     //如果是只有一个项目 直接新建
                    if(this.projectData.length==1){
                        this.$router.push('/manager/experiment/edit/'+this.projectData[0].id+'/'+this.projectData[0].formTemplateId+'/1/0')
                    }else{
                        this.form.topicHead = this.user.name
                        this.$refs['addDialog'].show()
                    }

                }


            },
            goExperimentEdit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const arr=this.form.project.split("$$$")
                        if(!arr[1]){
                            this.$message.error("该项目还未设定模板")
                            return
                        }
                        this.$router.push('/manager/experiment/edit/'+arr[0]+'/'+arr[1]+'/1/0')
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });
            },
            listExperiment(){
                this.loading = true;
                TypeList(this.searchText,this.noteId,this.selectGroupId,this.page,this.pageSize,this.sortType,this.sort).then(e => {
                   let data = this.APIParse(e);
                  this.experimentParentList = data?.hits.map(item => {
                    return item._source;
                  });
                  /**this.experimentParentList.forEach(item => {
                    this.$set(this.experimentMap,item.uuid, item.experimentList.map(item => {
                      return item._source;
                    }))
                  })*/
                  this.total = data.total || 0;
                }).catch(e => {
                    this.$message.error(e.message)
                }).finally(e => {
                    this.loading = false;
                })
            },
            deleteExperiment(row){
                this.$confirm('确定删除该实验吗？删除后可在回收站还原。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Delete(row.uuid).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("删除成功")
                            this.listExperiment();
                        }
                    }).catch(e => {
                        this.$message.error(e.message)
                    }).finally(e => {
                    })
                }).catch(() => {
                });

            },
            resetSign(){
            this.$refs.esign.reset();
            },
           saveSignImg(){
                if(!this.userSignature.password){
                     this.$message({
                      type: "warning",
                     message: "请输入签名密码",
                     });
                    return
                }
             var patten =/^\d{6}$/;
             if (!patten.test(this.userSignature.password)) {
               this.$message("请输入正确的密码格式");
               return false;
             }
            this.$refs.esign
                .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
                .then((res) => {
                  // 构造 FormData，并将签名图片对象和签名密码作为字段传入
                  this.signImg = res;
                  // this.$refs['addDialog'].hide();
                  // this.param.sign_img = res;a
                  this.userSignature.signature=res
                  if(!this.userSignature.signature){
                    this.$message({
                      type: "warning",
                      message: "您还没有签名",
                    });
                    return
                  }
                  SignatureSave(this.userSignature).then(e => {
                    if(e.code ==-1){
                      this.$message.error(e.msg)
                      return;
                    }
                    let data = this.APIParse(e)
                    this.submit()
                    this.$refs['addDia'].hide()
                    this.$message.success("签名保存成功")
                  })
                })
                .catch((err) => {
                  // 画布没有签字时会执行这里提示一下
                  this.$message({
                    type: "warning",
                    message: "您还没有签名",
                  });
                });

          },

            toGroupUserLink(row){
                this.$router.push({path:'/manager/groupUser/'+row.id})
            },
            changeGroupRole(){

            },
            changeShow(){
                if(this.experiment_show == 'my'){
                    this.groupId = ''
                    this.selectGroupId=''
                    this.noteId=''
                    this.isEdit = '0'
                }
                if(this.experiment_show == this.showGroupId){
                    this.groupId = this.showGroupId
                    this.selectGroupId=this.showGroupId
                    this.noteId=this.groupId
                    this.isEdit = '2'
                    if(this.groupId==this.UNSORTED_ID){
                        //this.isEdit = '0'
                        this.noteId=''
                    }

                }
                this.page = 1
                this.listExperiment();
            },
          handleSelect(val,val1) {
            if (val1.isSelect){
              this.selectExperiment.push(val1._source)
            }else {
              var index = this.selectExperiment.indexOf(val1._source);
              if (index !== -1) {
                this.selectExperiment.splice(index, 1);
              }
            }
          },
          handleSelectionChange1(val){
            if (val.length==this.experimentParentList.length){
              if(val.length == 0){
                this.experimentParentList.forEach((item,index)=>{
                  item.experimentList.forEach((ele,ind)=>{
                    this.$set(ele,'isSelect',false)
                  })
                })
              }else {
                this.experimentParentList.forEach((item, index) => {
                  item.experimentList.forEach((ele, ind) => {
                    this.$set(ele, 'isSelect', false)
                  })
                })
                val.forEach((item, index) => {
                  this.selectExperiment.push(item)
                  item.experimentList.forEach((ele, ind) => {
                    this.$set(ele, 'isSelect', true)
                    this.selectExperiment.push(ele._source);
                  })
                })
              }
            }else {
              this.experimentParentList.forEach((item,index)=>{
                item.experimentList.forEach((ele,ind)=>{
                  this.$set(ele,'isSelect',false)
                })
              })
              this.selectExperiment=val;
            }
          },
            // handleSelectionChange(val,val1){
            //     const id = val1.row._id ? val1.row._id : "9999";
            //     var filter = val.map(item =>  item._source);
            //     this.experimentSelect[id]=filter._source
            //     const  arr=[];
            //     for (let i in this.experimentSelect) {
            //      for (let j in this.experimentSelect[i]){
            //       arr.push(this.experimentSelect[i][j]._source)
            //      }
            //     }
            //    this.selectExperiment=arr;
            // },

            clearSelection(){
                // this.$refs.experiemnt.clearSelection();
              this.listExperiment()
            },
            tipShareOrCopy(type){
                if(this.selectExperiment.length==0){
                    this.$message.warning("请选择要"+type+"的实验！")
                    return false
                }
                if(this.selectExperiment.length>1){
                    this.$message.warning("一次只能"+type+"一个实验！")
                    return false
                }
                return true;
            },
            copyExperiment(){
                if(!this.tipShareOrCopy('复制')){
                    return
                }
                this.$refs['copyDialog'].show()
            },
            verify(){
              Verify(this.password).then(e => {
              let data = this.APIParse(e);
              if (data) {
                //this.$message.success("校验成功")
                this.$refs['userSignatureDialog'].hide()
                this.password=''
                this.submit()
              }else{
                this.$message.error("签名密码输入错误，请检查")
                this.password='';
              }
              })
            },
          submit(){
            this.$message.info("实验提交上链中，请耐心等待")
            this.loading = true;

            Submit(this.uuid,this.groupId,this.userSignature.signature).then(e => {
              this.loading = false;

              if (e.data) {
                this.$message.success("提交成功")
              }else{
                this.$message.error(e.msg)
              }
              this.groupId='';
              this.loading = true;
              this.listExperiment();
            })
          },
          goExperimentSubmit(row){
            this.$confirm('确定提交该实验吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              GetSignature().then(e => {
                     this.uuid=row.uuid
                     this.groupId=row.group_id[0]
                    if (e.data) {
                      this.userSignature = e.data;
                      this.$refs['userSignatureDialog'].show()
                    } else {
                      this.$refs['addDia'].show()
                    }
                  }
              ).catch(e => {
                this.$message.error(e.message)
              }).finally(e => {
              })
            })


          },
            goCopyExperiment(){
                if(!this.projectId){
                    this.$message.warning("")
                    return
                }
                this.$router.push('/manager/experiment/edit/'+this.projectId+'/'+this.selectExperiment[0].form_template_id+'/'+this.selectExperiment[0].uuid+'/1')
            },
            setShare(){
                if(!this.tipShareOrCopy('分享')){
                    return
                }
                GetShareList(this.selectExperiment[0]['group_id'][0]).then(e => {
                // let data = this.APIParse(e);
                     if (e.data){
                        if(e.data.length>0){
                            this.shareUserList=e.data
                            this.$refs['shareDialog'].show()
                        }else{
                            this.$message.warning("暂无可分享的用户")
                        }

                     }else{
                       this.$message.warning(e.msg)
                     }
                })
            },
          shareExperiment(){
            ShareExperiment(this.selectExperiment[0].uuid,this.shareIdList.join(",")).then(e => {
              let data = this.APIParse(e);
              if(e.code ==-1){
                this.$message.error(e.msg)
                return;
              }
              this.$message.success("分享成功")
              this.clearSelection();
              this.closeShare()
            })
          },
            closeShare(){
                this.$refs['shareDialog'].hide()
                this.checkGroupList = []
                this.checkShareUserList = []
                this.groupIdUserMap = {}
                this.groupObj = {}
            },
            changeGroup(){
                if("1"==this.groupObj.shareAppointPeople){
                    this.groupIdUserMap = {}
                    if(this.checkGroupList.length>0){
                        GetAllGroupUser(this.checkGroupList.join(",")).then(e => {
                            let data = this.APIParse(e);
                            data.forEach(item => {
                                if(!this.groupIdUserMap[item.groupId]){
                                    this.$set(this.groupIdUserMap,item.groupId,[item])
                                }else{
                                    let groupArr = this.groupIdUserMap[item.groupId]
                                    groupArr.push(item)
                                    this.$set(this.groupIdUserMap,item.groupId,groupArr)
                                }
                            })
                        })
                    }
                }
            },
            exportExcel(){
                if(this.selectExperiment.length==0){
                    this.$message.warning("请选择要导出的实验！")
                    return
                }
                this.$message.info("Excel导出中")
                ExportExcel(this.selectExperiment.map(e => {return e.uuid}).join(",")).then(e => {
                    let data = this.APIParse(e);
                    if(data.base64){
                        this.$message.success("导出成功")
                        this.downBlobToPage(data.base64,data.fileName)
                        this.clearSelection();
                    }
                }).catch(e => {
                    this.$message.error("Excel导出失败")
                })
            },
            exportWordOrPdf(type){
                if(this.selectExperiment.length==0){
                    this.$message.warning("请选择要导出的实验！")
                    return
                }
                this.$message.info(type+"导出中")
                ExportWordOrPdf(this.selectExperiment.map(e => {return e.uuid}).join(","),type).then(e => {
                    let data = this.APIParse(e);
                    if(data.base64){
                        this.$message.success("导出成功")
                        this.downBlobToPage(data.base64,data.fileName)
                        this.clearSelection();
                    }
                }).catch(e => {
                    this.$message.error(type+"导出失败")
                })
            },
             /*全部展开按钮点击方法*/
            ToExpandAll() {
              this.isOpenAll=false;
              const els = document.getElementsByClassName('el-table__expand-icon')
              if (this.experimentParentList.length !== 0&&els.length !== 0) {
                // 给所有的展开icon添加标记
                for (let j1 = 0; j1 < els.length; j1++) {
                  els[j1].classList.add('clickItem') 
                } 
                if (this.$el.getElementsByClassName('el-table__expand-icon--expanded')) {
                  const open = this.$el.getElementsByClassName('el-table__expand-icon--expanded')
                  // 去掉已经展开icon的标记
                  for (let j = 0; j < open.length; j++) {
                      open[j].classList.remove('clickItem') 
                  }
                  const clickItem = this.$el.getElementsByClassName('clickItem')
                  // 给所有未展开icon添加点击事件
                  for (let a = 0; a < clickItem.length; a++) {
                    clickItem[a].click() 
                  } 
                } 
              } 
            } ,
            ToClose() {
              this.isOpenAll=true;
              if (this.experimentParentList.length !== 0) {
                const elsopen = this.$el.getElementsByClassName('el-table__expand-icon--expanded')
                if (this.$el.getElementsByClassName('el-table__expand-icon--expanded')) {
                  // 给所有已经展开icon添加点击事件
                  for (let i = 0; i < elsopen.length; i++) {
                    elsopen[i].click() 
                  } 
                } 
              } 
            },
          tableRowClassName({row, rowIndex}) {
            return 'success-row';
          },
          toUpdateProject(exPerimentId){
            this.$confirm('您确定要更换项目吗？如存在子实验，将会同步更换。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  this.updateProjectForm.uuid=exPerimentId
                  this.$refs['updateProjectDialog'].show()
                }).catch(() => {  
                });
 

          },
          updateProject(){
            if(!this.updateProjectForm.projectId){
              this.$message.warning("请选择要归属的项目")
              return
            }
            UpdateProjectId(this.updateProjectForm.uuid,this.updateProjectForm.projectId).then(e => {
              let data = this.APIParse(e);
              if(e.code ==-1){
                this.$message.error(e.msg)
                return;
              }
              this.$message.success("操作成功")
              this.$refs['updateProjectDialog'].hide();
              this.updateProjectForm={uuid:'',projectId:''}
              this.listExperiment();
            })
          },
          loadCertificate(txid){
            this.loading = true;

            GetCertificate(txid).then(e => {
              this.loading = false;
                let data = this.APIParse(e);
                this.certificateUrl=data
                this.certificatePrivewUrl=encodeURIComponent(this.HKY_PRIVEW_URL+data)
                this.$refs['certificateUrlDialog'].show();
                }).catch(e => {
                    this.$message.error(e.message);
                })
          }
        }
    }
</script>
<style lang="scss" scoped>
    .group_operate+.group_operate{
        margin-left: 15px;
    }
    .Width-100{width: 100%}
    .home{width: 100%;height: 100%;overflow: auto;}
    .search_warp{width:100%;margin: 16px 0px;}

    .save_btn_warp{width: 100%;margin-top: 32px;display: flex;align-items: center;justify-content: center;}
    .page-warp{
        text-align: center;
        margin-top: 20px;
    }
    .sort_set{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 10px;
    }
.loadCertificate{
  cursor: pointer;
  margin-left:5px;
}


</style>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: rgba(0, 102, 255, 0.05) !important;
}
.el-table .base-button{
        margin-left: 0px;
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .Previewdialog .AppDialog__inner .AppDialog__content{
}
</style>